import { useEffect } from "react";

export function useMediaQueryEffect(
  query: string,
  onChange: (matches: boolean) => void,
): void {
  useEffect(() => {
    const mediaQuery = window.matchMedia(query);
    const handleChange = (event: MediaQueryListEvent) => {
      onChange(event.matches);
    };

    mediaQuery.addEventListener("change", handleChange);

    return () => {
      mediaQuery.removeEventListener("change", handleChange);
    };
  }, [onChange, query]);
}
